import { oneLine } from 'common-tags';

import type { FunctionComponent } from 'react';
import type { TypeGridItemProps } from './types';

/**
 * GridItem
 */
export const GridItem: FunctionComponent<TypeGridItemProps> = ({
  className = '',
  colSpanXS = 1,
  colSpanMD,
  colSpanLG,
  rowSpanXS = 1,
  rowSpanMD,
  rowSpanLG,
  children,
}: TypeGridItemProps) => (
  <div
    className={oneLine`
      col-span-${colSpanXS}
      ${colSpanMD ? `md:col-span-${colSpanMD}` : ''} 
      ${colSpanLG ? `lg:col-span-${colSpanLG}` : ''} 
      row-span-${rowSpanXS}
      ${rowSpanMD ? `md:row-span-${rowSpanMD}` : ''} 
      ${rowSpanLG ? `lg:row-span-${rowSpanLG}` : ''} 
      ${className}
    `}
  >
    {children}
  </div>
);
